import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import configureStore from './redux/configure-store';

import './config/ReacToTronConfig';

import Routes from './routes';
import history from './services/history';
import GlobalStyle from './styles/global';

const [store, persistor] = configureStore();

export default class App extends React.Component {
  componentDidMount () {
    document.title = 'Calgaro'
  }

  render () {
    return (
      <Provider store={store}>
        <Router history={history}>
          <PersistGate persistor={persistor}>
            <Routes />
            <GlobalStyle />
          </PersistGate>
        </Router>
      </Provider>
   );
  }
}